/* Source: /home/sidsolaiyappan/skooch_ai/shared/chat_mic_button.jac */
import {__jacJsx, __jacSpawn} from "@jac/runtime";
import { useState } from "react";
import { voiceSupported, startVoiceCapture } from "./voice_capture.js";
import { cleanTranscript } from "./voice_text.js";
function ChatMicButton(props) {
  let _onTranscript = props["onTranscript"];
  let _lp = useState(false);
  let _listening = _lp[0];
  let _setListening = _lp[1];
  if (!voiceSupported()) {
    return null;
  }
  let _onClick = () => {
    if (_listening) {
      return;
    }
    _setListening(true);
    startVoiceCapture(_t => {
      try {
        if (_onTranscript) {
          _onTranscript(cleanTranscript(_t));
        }
      } catch (__jac_e) {
        if (true) {
          let _er = __jac_e;
        } else {
          throw __jac_e;
        }
      }
    }, () => {
      _setListening(false);
    });
  };
  return __jacJsx("button", {"type": "button", "className": (_listening ? "ai-chat-mic ai-chat-mic-on" : "ai-chat-mic"), "aria-label": (_listening ? "Listening\u2026" : "Voice input"), "title": "Speak a task", "onClick": () => {
    _onClick();
  }}, ["\ud83c\udfa4"]);
}
export {ChatMicButton};
if (typeof globalThis !== "undefined") { if (!globalThis.__jacEndpointEffects__) globalThis.__jacEndpointEffects__ = {}; Object.assign(globalThis.__jacEndpointEffects__, {"func:ChatMicButton": {"is_writer": false, "touches": ["*"]}}); };
//# sourceMappingURL=chat_mic_button.js.map
